import "core-js/modules/es.array.push.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "title"
};
import "particles.js";
import { onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { http, showMsg } from "@/util/myTools";
import { useStore } from "vuex";
export default {
  __name: 'Login',
  setup(__props) {
    const store = useStore();
    const router = useRouter();
    const urlParams = new URLSearchParams(window.location.search);
    const username = urlParams.get('name');
    const loginForm = reactive({
      userName: username,
      password: ""
    }); //表单绑定的响应式对象

    const loginFormRef = ref(); //表单的引用对象

    const loginRules = reactive({
      userName: [{
        required: true,
        message: "请输入用户名",
        trigger: "blur"
      }],
      password: [{
        required: true,
        message: "请输入密码",
        trigger: "blur"
      }]
    });
    const submitForm = () => {
      loginFormRef.value.validate(async valid => {
        if (valid) {
          const res = await http("/login", "post", loginForm);
          console.log(res);
          if (res.status == 1) {
            store.commit("changeUserInfo", res.data);
            localStorage.setItem("token", res.data.token);
            router.push("/attendance");
          } else {
            showMsg(res);
          }
        }
      });
    };
    onMounted(() => {
      login();
    });
    const login = async () => {
      localStorage.removeItem("token");
      const res = await http("/login", "post", loginForm);
      store.commit("changeUserInfo", res.data);
      localStorage.setItem("token", res.data.token);
      router.push("/attendance");
    };
    const initParticles = () => {
      particlesJS("particles-js", {
        particles: {
          number: {
            value: 80,
            density: {
              enable: true,
              value_area: 800
            }
          },
          color: {
            value: "#ffffff"
          },
          shape: {
            type: "circle",
            stroke: {
              width: 0,
              color: "#fffff"
            },
            polygon: {
              nb_sides: 5
            }
          },
          opacity: {
            value: 0.5,
            random: false,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false
            }
          },
          size: {
            value: 6,
            random: true,
            anim: {
              enable: false,
              speed: 40,
              size_min: 0.1,
              sync: false
            }
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: "#ffffff",
            opacity: 0.4,
            width: 3
          },
          move: {
            enable: true,
            speed: 0.5,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200
            }
          }
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: {
              enable: true,
              mode: "grab"
            },
            onclick: {
              enable: true,
              mode: "push"
            },
            resize: true
          },
          modes: {
            grab: {
              distance: 140,
              line_linked: {
                opacity: 1
              }
            },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3
            },
            repulse: {
              distance: 200,
              duration: 0.4
            },
            push: {
              particles_nb: 4
            },
            remove: {
              particles_nb: 2
            }
          }
        },
        retina_detect: true
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, " 你无权访问");
    };
  }
};